import { FC } from 'react';
import { useAppSelector } from '../../app/hooks';
import { selectSessionStatus } from '../../app/slices/session.slice';
import ConsumerInputNeededRouter from './ConsumerInputNeededRouter';
import FinishedStep from '../finished/FinishedStep';
import SessionErrorPage from '../session-error/SessionErrorPage';
import { AbortedStep } from '../aborted/AbortedStep';
import { ProcessingStep } from '../processing/ProcessingStep';
import AuthRejectedStep from '../auth-rejected/AuthRejectedStep';
import ConsentExpiredStep from '../consent-expired/ConsentExpiredStep';

export const Session: FC = () => {
	const status = useAppSelector(selectSessionStatus);

	switch (status) {
		case 'CONSUMER_INPUT_NEEDED':
			return <ConsumerInputNeededRouter />;
		case 'PROCESSING':
			return <ProcessingStep />;
		case 'ABORTED':
			return <AbortedStep />;
		case 'FINISHED':
			return <FinishedStep />;
		case 'EXCEPTION':
			return <SessionErrorPage />;
		case 'AUTH_REJECTED':
			return <AuthRejectedStep />;
		case 'CONSENT_EXPIRED':
			return <ConsentExpiredStep />;
		default:
			return <></>;
	}
};
